var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"stroke-current",class:_vm.classes,attrs:{"width":_vm.dimensions,"height":_vm.dimensions}},[_c('use',_vm._b({},'use',{
      'xlink:href': `${require('~/assets/svg/icons.svg')}#${_vm.id}`,
    },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }